<script lang="ts">
	import { ShopCheckoutContext } from '#lib/websites/shop/components/ShopCheckoutContext/index.js';
	import { ShopHeader } from '#lib/websites/shop/components/ShopHeader/index.js';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
</script>

<ShopCheckoutContext>
	<ShopHeader />
	{@render children?.()}
</ShopCheckoutContext>
